class WindowContoller {
	constructor(LocationService) {
		this.LocationService = LocationService;
		this.locations = [];
	}

	$onInit() {
		if (!this.branch) {
			return;
		}

		const locationSearchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.branch
                    },
                    {
                        field: 'locationType',
                        condition: '=',
                        data: 'WINDOW'
                    }
                ],
                operator: 'AND'
            }
        };

		return this.LocationService.getAllLocation(locationSearchObj, 0, 1000)
			.then((data) => {
				this.locations = data.results;
			}).catch((err) => {
				console.error(err);
			})
	}

	valueChanged() {
		this.model.isSaved = false;
	}
}

WindowContoller.$inject = ['LocationService'];

export default WindowContoller;


// WEBPACK FOOTER //
// ./client/app/components/branch/common/window/window.controller.js